export default __webpack_public_path__ + "static/media/Backcover.476c97b1.txt";